import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';

import { DashboardMemberDetails, MemberSessionAndReportSummary } from '../../../api/report/types';
import { RequestStatusWithDetails } from '../../../types/RequestStatusWithDetails';
import loadDashBoardData from './asyncReducers/loadDashboardData';
import loadMemberSessionAndReoprtSummaries from './asyncReducers/loadMemberSessionAndReportSummaries';

export type MemberId = string;

export type MemberDataSlice = {
    /**
     * Member summary data is loaded for all members togather
     */
    memberDashboardSummaries: RequestStatusWithDetails<Record<MemberId, DashboardMemberDetails>>;

    /**
     * Member session data is loaded for each individual member
     */
    memberSessionAndReportSummaries: Record<MemberId, RequestStatusWithDetails<MemberSessionAndReportSummary[]>>;
};

export const initialState: MemberDataSlice = {
    memberDashboardSummaries: { status: 'idle' },
    memberSessionAndReportSummaries: {},
};

export const memberSlice = createSlice({
    name: 'members',
    initialState,
    reducers: {},
    extraReducers: (builder: ActionReducerMapBuilder<MemberDataSlice>) => {
        loadDashBoardData(builder);
        loadMemberSessionAndReoprtSummaries(builder);
    },
});

export default memberSlice.reducer;
